<template>
  <div class="mainPage">
    <div class="loginBox">
      <div class="logo-container">
        <div class="logo-circle">
          <img src="../assets/logoKjk.png" alt="">
        </div>
      </div>
      
      <p id="headTitle">SIKU RAJA</p>
      <p id="title">SISTEM KEUANGAN KURNIA JAYA KARYA</p>
      
      <form @submit.prevent="login" class="form-container">
        <div class="input-group">
          <input type="text" required v-model="username" placeholder="Username" />
          <span class="input-icon">👤</span>
        </div>
        
        <div class="input-group">
          <input type="password" v-model="password" required placeholder="Password" />
          <span class="input-icon">🔒</span>
        </div>
        
        <button type="submit">
          <span>LOGIN</span>
          <div class="button-glow"></div>
        </button>
      </form>
      
      <!-- efek salju -->
      <!-- <div class="snow-container" id="snowflakes">
        <div class="snowflake" style="--size: 10px; --delay: 0s;"></div>
        <div class="snowflake" style="--size: 8px; --delay: 2s;"></div>
        <div class="snowflake" style="--size: 12px; --delay: 4s;"></div>
        <div class="snowflake" style="--size: 6px; --delay: 1s;"></div>
        <div class="snowflake" style="--size: 14px; --delay: 3s;"></div>
        <div class="snowflake" style="--size: 9px; --delay: 5s;"></div>
      </div> -->
    </div>
  </div>
</template>

<script>
import axios from '../API/axios';
import Swal from "sweetalert2";
import moment from 'moment';
import '../assets/Miraculous&Christmas.ttf'
export default {
  name: "LoginPage",
  data() {
    return {
      username: '',
      password: "",
      number: 0,
      numberFormatted: '0',
      audioSrc: require('../assets/okgas.mp3')
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  mounted() {
    this.animateSnowflakes();
  },
  methods: {
    animateSnowflakes() {
      const snowflakes = document.querySelectorAll('.snowflake');
      snowflakes.forEach((flake, index) => {
        flake.style.animationDelay = `${Math.random() * 10}s`;
        flake.style.animationDuration = `${5 + Math.random() * 5}s`;
      });
    },
    async login() {
      try {
        let data = await axios({
          method: 'post',
          url: "/user/login",
          data: {
            username: this.username,
            password: this.password,
          },
        });
        let date = moment(new Date()).format("YYYY-MM-DD");
        console.log(data, "data");
        localStorage.setItem('access_token', data.data.access_token);
        localStorage.setItem('role', data.data.role);
        localStorage.setItem('username', data.data.username);
        localStorage.setItem('date', date);
        Swal.fire("Semangat Pagi", "Semangat Pagi, Semangat Bekerja", "success");
        this.$store.commit("setIsLogin", true);
        this.$store.dispatch('getLocalStorage');
        this.$router.push("/");
      } catch (err) {
        Swal.fire("Maaf", "Password/username anda salah", "error");
      }
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.mainPage {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, 
    #667eea 0%, 
    #764ba2 25%, 
    #f093fb 50%, 
    #f5576c 75%, 
    #4facfe 100%);
  background-size: 400% 400%;
  animation: gradientShift 15s ease infinite;
  position: relative;
  overflow: hidden;
  font-family: 'Mountains of Christmas', cursive, -apple-system, BlinkMacSystemFont, sans-serif;
}

@keyframes gradientShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.loginBox {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 30px;
  padding: 3rem 4rem;
  box-shadow: 
    0 25px 45px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(255, 255, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  position: relative;
  max-width: 30rem;
  width: 90%;
  text-align: center;
}

.logo-container {
  margin-bottom: 2rem;
}

.logo-circle {
  width: 80px;
  height: 80px;
  /* background: linear-gradient(135deg, #ff9a9e, #fecfef); */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  box-shadow: 0 10px 30px rgba(255, 154, 158, 0.4);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.logo-icon {
  font-size: 2.5rem;
}

#headTitle {
  color: #ffffff;
  font-size: 2.8rem;
  margin: 1rem 0 0.5rem 0;
  font-weight: 700;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  letter-spacing: 2px;
}

#title {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.1rem;
  margin: 0 0 3rem 0;
  font-weight: 500;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.logo-circle img {
  max-width: 10rem;
  height: auto;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.input-group {
  position: relative;
  margin-bottom: 0;
}

.input-group input {
  width: 100%;
  padding: 16px 20px 16px 50px;
  font-size: 16px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  color: #ffffff;
  font-weight: 500;
  transition: all 0.3s ease;
  font-family: inherit;
}

.input-group input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.input-icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  pointer-events: none;
}

.input-group input:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

button {
  position: relative;
  padding: 16px 0;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 16px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-top: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

button:hover::before {
  left: 100%;
}

button:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(102, 126, 234, 0.4);
}

.snow-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  border-radius: 30px;
}

.snowflake {
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  animation: snowfall linear infinite;
}

.snowflake::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50%;
  height: 50%;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

@keyframes snowfall {
  0% {
    transform: translateY(-100vh) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(100vh) rotate(360deg);
    opacity: 0;
  }
}

.snowflake {
  width: var(--size);
  height: var(--size);
  left: calc(var(--random-x, 0) * 100%);
  animation-duration: calc(10s + var(--random-duration, 0) * 5s);
  animation-delay: var(--delay);
}

/* Responsive */
@media (max-width: 480px) {
  .loginBox {
    padding: 2rem 2.5rem;
    margin: 1rem;
  }
  
  #headTitle {
    font-size: 2.2rem;
  }
  
  .logo-circle {
    width: 60px;
    height: 60px;
  }
  
  .logo-icon {
    font-size: 2rem;
  }
}
</style>